import { useDispatch, useSelector } from "react-redux";
import { actionGetOtherQuoteList, resetGetOtherQuoteList } from "./store";
import OtherQuoteCard from "../../../../component/other_quote_card";
import { useEffect, useState } from "react";
import Contact from "../../../../component/contact";
import { actionSourceForEnquiry, resetGetSource } from "../policies/store";
import { PJ_URL } from "../../../../common/constant";

const OtherQuoteList = () => {

  const dispatch = useDispatch();
  const [allOtherQuoteList, setAllOtherQuoteList] = useState([]);

  // Stored Quote List 
  const { getOtherQuoteList } = useSelector(state => ({
    ...state.otherQuoteListStore,
  }));


  // Other Quote List Api Call
  useEffect(() => {
    dispatch(actionGetOtherQuoteList());
  }, []);


  const { getSource } = useSelector(state => ({
    ...state.policyStore,
  }));

  useEffect(() => {
    if (getSource) {
      if (getSource.status === true) {
        dispatch(resetGetSource());
        console.log(getSource);
        const token = localStorage.getItem("token");
        const url = `${PJ_URL}?token=${token}&source=${getSource.data?.source}&quote_id=${getSource.data?.quoteId}`;
        window.open(url, '_blank');
        return
      }
    }
  }, [getSource])

  const handleGetSource = (item) => {
    const payload = { value: item.quote_type === "Personal" ? "Personal" : "Corporate" }
    if (item.previous_policy_id === 0) {
      payload.type = "new";
    }
    dispatch(actionSourceForEnquiry(payload))
  }

  // store data from "getOtherQuoteList" in state "setAllOtherQuoteList"
  useEffect(() => {
    if (getOtherQuoteList !== null) {
      dispatch(resetGetOtherQuoteList());
      if (getOtherQuoteList?.status === true) {
        setAllOtherQuoteList(getOtherQuoteList?.data);
      }
    }

  }, [getOtherQuoteList])
  return (
    <>



      <div className="row mt-6">
        <div className="col-12 mb-3">
          <div>
            <div>
              <h5 className="mb-0 ">Quotes</h5>
            </div>
          </div>

        </div>
        <div className="col-12 col-md-8">

        </div>
        <div className="col-12">
          <div className=" row justify-content-between tab-menu">
            <div className="col-12 col-md-6">

              <button class="btn btn-light btn-sm active">  All Quotes ({`${allOtherQuoteList?.length}`})</button>

            </div>
          </div>
        </div>
      </div>
      <div className="row  mb-5 mt-3">
        <div className="col-12 col-md-9">
          {
            allOtherQuoteList != null && allOtherQuoteList?.length > 0 ? (
              allOtherQuoteList.map((item, index) => (
                <div key={index}>
                  <OtherQuoteCard
                    detail={item}
                    detailIndex={index}
                    handleGetSource={() => handleGetSource(item)}
                  />
                </div>
              ))
            ) : (
              <>
                <div className="d-flex justify-content-center align-items-center mt-5">
                  <h5>No Quotes To Display</h5>
                </div>
              </>
            )
          }
        </div>
        <div className="col-12 col-md-3">
          <Contact />
        </div>
      </div>
    </>
  )
}

export default OtherQuoteList